import React from "react";
import { Box, Typography } from "@mui/material";

interface OverlayProps {
  text: string;
  show: boolean;
  children: React.ReactNode;
  blur?: number;
}

const Overlay: React.FC<OverlayProps> = ({ text, show, children, blur = 2 }) => (
  <Box sx={{ position: "relative", display: "inline-block" }}>
    {children}

    {show && (
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          bgcolor: "rgba(255, 255, 255, 0.8)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backdropFilter: `blur(${blur}px)`,
          borderRadius: 1,
          zIndex: 1
        }}
      >
        <Typography fontWeight="bold">{text}</Typography>
      </Box>
    )}
  </Box>
);

export default Overlay;
